import React, { useEffect, useState } from 'react'
import { FieldIntegrationRow } from './AIGeneratedFields'
import { useFormContext } from 'react-hook-form'
import { FormRow, FormValues } from './CrmField'
import { generateId } from '../../../common/util'

const contactLinkingSupportedConnectors = ['salesforce', 'xlr8', 'practifi']

interface ContactLinkTabProps {
  connector: string
}

export const ContactLinkTab: React.FC<ContactLinkTabProps> = ({ connector }) => {
  const { watch, setValue } = useFormContext<FormValues>()
  const formFields = watch('mappingFormFields')

  const selectedObjects = formFields
    .map((field) => field.objectName)
    .filter((value, index, array) => array.indexOf(value) === index)
    .filter((value): value is string => value !== null)
  if (!contactLinkingSupportedConnectors.includes(connector)) {
    return null
  }

  return (
    <div>
      <div>Set up how each mapped object links to your client contact to keep all data organized under the right person in your CRM.</div>
      {selectedObjects.map((object) => {
        return <ContactLinkRow connector={connector} selectedObjects={selectedObjects} object={object} />
      })}
    </div>
  )
}

type ContactLinkRowProps = {
  connector: string
  selectedObjects: string[]
  object: string
}

const ContactLinkRow: React.FC<ContactLinkRowProps> = ({ connector, selectedObjects, object }) => {
  const { watch, setValue } = useFormContext<FormValues>()
  const formFields = watch('mappingFormFields')
  const [contactFormRow, setContactFormRow] = useState<FormRow | null>(null)

  useEffect(() => {
    const existingRow = formFields.find((row) => row.objectName === object && row.value === 'contactId')
    if (existingRow) {
      setContactFormRow(existingRow)
    } else {
      setValue('mappingFormFields', [
        ...formFields,
        {
          key: generateId(),
          objectName: object,
          fieldName: null,
          value: 'contactId',
          type: 'variable',
        } as FormRow,
      ])
    }
  }, [selectedObjects, object])

  return (
    <div key={object} className='d-flex align-items-center mt-3 mb-2'>
      <div style={{ width: '200px' }} className='me-2'>
        Contact link for {object}
      </div>

      {!contactFormRow ? (
        <div className='skeleton w-100 h-25' />
      ) : (
        <FieldIntegrationRow
          formRow={contactFormRow}
          type='variable'
          connector={connector}
          showFieldTitle={false}
          selectedObjects={selectedObjects}
          objectSelectDisabled={true}
        />
      )}
    </div>
  )
}
